module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "clear"
  }), _vm._m(1), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary configure",
    on: {
      "click": _vm.redirect
    }
  }, [_vm._v("Configurar e-mail")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('img', {
    staticClass: "computer",
    attrs: {
      "src": require("../../assets/images/icons/icon-computer.svg")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('span', {
    staticClass: "message"
  }, [_vm._v("Antes de começar a usar o Reev, você deve conectar-se ao seu e-mail clicando no botão abaixo.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e157cf5e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/index_nylas.vue
// module id = 1225
// module chunks = 1